import {
  ClusterFilterKeys,
  ClusterListUrlFiltersOpts,
  ClusterProductType
} from "@saleor/cluster/components/ClusterListPage/filters";
import { IFilterElement } from "@saleor/components/Filter";
import { findValueInEnum, maybe } from "@saleor/misc";
import { ClusterInput } from "@saleor/types/globalTypes";

import {
  createFilterTabUtils,
  createFilterUtils,
  getSingleEnumValueQueryParam
} from "../../../utils/filters";
import {
  ClusterListUrlFilters,
  ClusterListUrlFiltersEnum,
  ClusterListUrlQueryParams
} from "../../urls";
export const CLUSTER_FILTERS_KEY = "clusterFilters";

export function getFilterOpts(
  params: ClusterListUrlFilters
): ClusterListUrlFiltersOpts {
  return {
    productType: {
      active: maybe(() => params.productType !== undefined, false),
      value: maybe(() =>
        findValueInEnum(params.productType, ClusterProductType)
      )
    }
  };
}

export function getFilterVariables(
  params: ClusterListUrlFilters
): ClusterInput {
  return {
    search: params.query
  };
}

export function getFilterQueryParam(
  filter: IFilterElement<ClusterFilterKeys>
): ClusterListUrlFilters {
  const { name } = filter;

  switch (name) {
    case ClusterFilterKeys.productType:
      return getSingleEnumValueQueryParam(
        filter,
        ClusterListUrlFiltersEnum.productType,
        ClusterProductType
      );
  }
}

export const {
  deleteFilterTab,
  getFilterTabs,
  saveFilterTab
} = createFilterTabUtils<ClusterListUrlFilters>(CLUSTER_FILTERS_KEY);

export const { areFiltersApplied, getActiveFilters } = createFilterUtils<
  ClusterListUrlQueryParams,
  ClusterListUrlFilters
>(ClusterListUrlFiltersEnum);
